<mat-sidenav-container class="sidenav-container dealer-layout">

  <mat-sidenav #drawer class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">

    <div class="app-sidebar">
      <app-portal-sidebar [menuItems]="menuItems"
        [ownerType]="ownerType"
        [moduleName]="ownerType === ownerTypeEnum.BASATA ? 'basata' : 'tfb'">
      </app-portal-sidebar>
    </div>

  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="mat-elevation-z0">
      <button (click)="drawer.toggle()" class="text-primary" mat-icon-button type="button">
        <mat-icon class="text-primary" svgIcon="menu-white"></mat-icon>
      </button>

      <div routerLink="/home" class="d-flex align-items-center col-1 cursor-pointer"
        matTooltip="AQRBMIS">

          <span class="fs-6 text-primary fw-bolder">
            AQRBMIS <span class="fw-lighter">AQRBMIS</span>
          </span>

      </div>

      <span class="spacer"></span>

      <app-main-toolbar></app-main-toolbar>
    </mat-toolbar>

    <div class="container staff-main py-3">
      <div class="contents p-3">
        <router-outlet></router-outlet>
      </div>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
